import apiClient from "./apiClient"

export type RequestMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH"

interface RequestOptions {
  url: string
  method?: RequestMethod
  data?: any
  params?: Record<string, any>
  headers?: Record<string, string>
  withCredentials?: boolean
}

export const request = async <T = any>({
  url,
  method = "GET",
  data,
  params,
  headers,
  withCredentials,
}: RequestOptions): Promise<T> => {
  const response = await apiClient.request<T>({
    url,
    method,
    data,
    params,
    headers,
    withCredentials,
  })

  return response.data
}
